module.exports = __webpack_public_path__ + "c61b83cbc9046dde64d741cc099b6f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/images/img_grediant_circle_1.jpg
// module id = 406
// module chunks = 0